import ConsultCard from "@/features/appointments/components/ConsultCard"
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType as NewEventType } from "@/features/events/types/EventType"
import { saveEvent } from "@/utils/apis/user-service"
import { EventType } from "@/utils/enums/EventType"
import { useAuthStore } from "@/utils/stores/useAuthStore"
import { useConsultsStore } from "@/utils/stores/useConsultsStore"
import { useUserStore } from "@/utils/stores/useUserStore"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useGetAppointments } from "../appointments/hooks/useGetAppointments"
import FolderCard from "../shared/components/FolderCard"

const EquipeCards = [
  {
    route: "your-appointments",
    title: "🗓️ I tuoi appuntamenti",
    eventKey: "your_appointments_folder_clicked",
  },
  {
    route: "your-experts",
    title: "👩‍⚕️👨‍⚕️ I tuoi Professionisti",
    eventKey: "your_experts_folder_clicked",
  },
]

const Equipe = () => {
  const { auth } = useAuthStore()
  const idToken = auth.idToken
  const { userData } = useUserStore()
  const email = userData.email
  const navigate = useNavigate()
  const { sendEvent } = useCreateEvent()
  const { consultsData } = useConsultsStore()
  const mostRecentAppointment = consultsData.mostRecentFutureAppointment

  const { refetch: refetchAppointments } = useGetAppointments()

  const handleFolderClick = async (navigateTo: string, eventKey: string) => {
    navigate(navigateTo);
    if (!email) return;
    saveEvent(
      email,
      eventKey,
      (success) => {
        console.log(success);
      },
      (error) => {
        console.log(error);
      },
      "equipe_page"
    );

    await sendEvent({
      event: NewEventType.CLICK,
      sub_category: "open_equipe_folder",
      event_metadata: { folder: navigateTo }
    })
  };

  useEffect(() => {
    if (!email || !idToken) return
    saveEvent(
      email,
      EventType.PageView,
      (success) => { console.log() },
      (error) => { console.log(error) },
      "equipe_page",
    )

    void sendEvent({
      event: NewEventType.PAGE_VIEW,
      sub_category: "euipe_page",
    })
  }, [])

  useEffect(() => {
    refetchAppointments()
  }, [])

  // ********************************************************************************

  return (
    <div className="w-full h-full flex flex-col space-y-sm">
      {
        mostRecentAppointment &&
        <>
          <div className="font-bold">
            Prossimo appuntamento
          </div>
          <ConsultCard
            appointment={mostRecentAppointment}
          />
        </>
      }
      <div className="w-full h-full flex flex-col space-y-sm mt-[20px]">
        {
          EquipeCards.map((card, index) => (
            <FolderCard key={`${card.title}-${index}`} onClick={() => handleFolderClick(card.route, card.eventKey)} title={card.title} />
          ))
        }
      </div>
      <div className="p-[10px]" />
    </div>
  )
}

export default Equipe
